
import { Button } from "@/components/ui/button";
import { HeartButton } from "@/components/ui/heart-button";
import { MessageCircle } from "lucide-react";
import { ShareMenu } from "@/components/ui/ShareMenu";

interface PostInteractionsProps {
  onLikeToggle: () => Promise<void>;
  isLiked: boolean;
  likesCount: number;
  commentsCount: number;
  postId: string;
  title: string;
  imageUrl: string;
}

export function PostInteractions({
  onLikeToggle,
  isLiked,
  likesCount,
  commentsCount,
  postId,
  title,
  imageUrl,
}: PostInteractionsProps) {
  // Ensure imageUrl is absolute
  const absoluteImageUrl = imageUrl.startsWith('http') 
    ? imageUrl 
    : `${window.location.origin}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;

  // Use the direct post URL for sharing
  const postUrl = `${window.location.origin}/pin/${postId}`;

  return (
    <div className="flex items-center gap-4 py-4 border-t border-b">
      <HeartButton 
        onToggle={onLikeToggle}
        isLiked={isLiked}
        initialCount={likesCount}
      />
      
      <Button variant="ghost" size="sm" className="gap-1">
        <MessageCircle className="h-4 w-4" /> {commentsCount}
      </Button>
      
      <ShareMenu 
        title={title}
        url={postUrl}
        imageUrl={absoluteImageUrl}
      />
    </div>
  );
}
